import { useClientContractTermDetail } from './hooks';
import { convertToPresentationProps } from './logics';
import { ClientContractTermDetailPresentation } from './presentations';

type Props = {
  /** 利用企業 ID（Screen 層でパース・検証済みの数値） */
  clientId: number;
  /** 企業契約期間 ID（Screen 層でパース・検証済みの数値） */
  termId: number;
};

/**
 * 企業契約期間 詳細 Container
 *
 * @param clientId - 利用企業 ID（Screen 層でパース・検証済みの数値）
 * @param termId - 企業契約期間 ID（Screen 層でパース・検証済みの数値）
 *
 * ## 注意
 * - Suspense（`suspense: true`）でデータ取得を行うため、エラー時は ErrorBoundary に委譲される
 * - 編集ボタンは表示しない（PartnerAdmin は契約期間を編集できない仕様）
 * - PartnerAdmin 用 API に created_at / updated_at がないため、作成日時・更新日時は暫定で「-」を表示
 */
export const ClientContractTermDetail: React.FC<Props> = ({ clientId, termId }) => {
  const {
    state: { data },
  } = useClientContractTermDetail({ clientId });

  const {
    clientName,
    contractPlanName,
    contractPlanLink,
    startedOnLabel,
    endedOnLabel,
    createdAtLabel,
    updatedAtLabel,
  } = convertToPresentationProps({ data, termId });

  return (
    <ClientContractTermDetailPresentation
      clientName={clientName}
      contractPlanName={contractPlanName}
      contractPlanLink={contractPlanLink}
      startedOnLabel={startedOnLabel}
      endedOnLabel={endedOnLabel}
      createdAtLabel={createdAtLabel}
      updatedAtLabel={updatedAtLabel}
    />
  );
};
